module.exports = __webpack_public_path__ + "static/media/pectoralis_major_right_weak.48ee9899.png";